import { OrderProductDetailsInput, VoucherData } from 'graphql/types'
import { ViewType } from 'store/GeneralState/GeneralState.reducer'
import { pathToViewType } from 'utils/testable/pathToViewType'

// etracker custom dimension for the zip code of the customer. The name of the
// parameter (et_seg1 ... et_seg5) is given by the dimension in the etracker
// account (Account > Datenanreicherung > Eigene Dimensionen).
const zipDimension = 'et_seg1'

// zip code that was already sent to etracker. The dimension is attached to the
// visit from the page view it is sent with, so it is only sent once and again
// when the customer entered a new address
let trackedZip = ''

export const executeTrackingCall = (page: string, zip?: string): void => {
    // the availability check is where the customer enters a (new) address, so
    // the zip is not sent there and the following one is sent again
    const onAvailabilityCheck = page === '/'
    if (onAvailabilityCheck) {
        trackedZip = ''
    }

    // @ts-expect-error: __envConfig came from backend
    if (typeof _etracker === 'object') {
        const viewType = pathToViewType(page)
        const pageParts = page.split('/')
        let pageName = pageParts[1]
        if (viewType === ViewType.AVAILABILITY_CHECK) {
            pageName = 'Verfügbarkeitsprüfung'
        } else if (viewType === ViewType.PRODUCT_SELECTION || viewType === ViewType.PRODUCT_CROSS_SELLING) {
            pageName += '/' + pageParts[2]
        } else if (viewType === ViewType.OPTIONS_CONFIGURATION) {
            pageName += '/' + pageParts[4] + '/' + pageParts[2]
        } else if (viewType === ViewType.PRODUCT_TYPE_SELECTION) {
            pageName += '/' + pageParts[3]
        } else if (viewType === ViewType.VZF_VIEW) {
            pageName = 'Vertrags­zusammen­fassung'
        }
        const params: Record<string, string> = { et_et: '4w3GQb', et_pagename: pageName }
        if (!onAvailabilityCheck && zip && zip !== trackedZip) {
            console.log('tracked zip: ', zip)
            params[zipDimension] = zip
            trackedZip = zip
        }
        // @ts-expect-error: __envConfig came from backend
        et_eC_Wrapper(params)
    }
}

export const executeTrackingOrder = (
    orderData: OrderProductDetailsInput,
    vouchers: VoucherData[],
    orderNumber: string,
): void => {
    // @ts-expect-error: etCommerce comes from etracker script
    if (typeof etCommerce === 'object') {
        const ArtGruppeMapping: Record<string, string> = {
            combi: 'Kombi',
            internet: 'Internet',
            television: 'Fernsehen',
            telephone: 'Telefon',
        }

        const products: {
            product: { id: string; name: string; price: string; currency: string; category: string[] }
            quantity: number
        }[] = []

        for (const category of orderData.categories) {
            const product = category.products
            products.push({
                product: {
                    id: product.id,
                    name: product.technicalID,
                    price: String(product.priceGross),
                    currency: 'EUR',
                    category: [ArtGruppeMapping[category.identifier]],
                },
                quantity: 1,
            })

            for (const productType of product.productTypes) {
                if (productType.optional) {
                    products.push({
                        product: {
                            id: productType.id,
                            name: productType.title,
                            price: String(productType.priceGross),
                            currency: 'EUR',
                            category: [ArtGruppeMapping[category.identifier]],
                        },
                        quantity: 1,
                    })
                }
            }
        }

        let monthlyPrice = String(orderData.monthlyPrice)
        //get the order price check first if monthly increments is empty
        if (orderData.monthlyIncrements != null && orderData.monthlyIncrements.length > 0) {
            monthlyPrice = String(orderData.monthlyIncrements[orderData.monthlyIncrements.length - 1].value)
        }

        const order = {
            orderNumber: orderNumber,
            status: 'sale',
            orderPrice: monthlyPrice,
            currency: 'EUR',
            basket: {
                id: orderNumber,
                products: products,
            },
        }

        // @ts-expect-error: etCommerce comes from etracker script
        window._etrackerOnReady = typeof window._etrackerOnReady === 'undefined' ? [] : window._etrackerOnReady
        // @ts-expect-error: etCommerce comes from etracker script
        window._etrackerOnReady.push(function () {
            // @ts-expect-error: etCommerce comes from etracker script
            etCommerce.sendEvent('order', order)
        })
    }
}
